
export class MailAttention {
    id: number;
    mailAttentionName: string;
    status: boolean;
}